module.exports = __webpack_public_path__ + "img/Alaska_Denali.60b52932.jpg";